<template>
  <v-container
    id="clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <dashboard-filtro-datas
              :primeiro="enablePrimeiroDia"
              :ultimo="enableUltimoDia"
              :empresas="enableEmpresa"
              :url="link"
              :vendedores="enableVendedores"
              :areas="enableAreas"
              :redes="enableRedes"
              :supervisores="enableSupervisor"
              :receitas="enableReceita"
              :segmentos="enableSegmento"
              :categorias="enableCategoria"
              :promotores="enablePromotor"
            />
          </v-col>
          <v-row
            id="opcoesClientes"
            no-gutters
          >
            <v-col
              md="4"
              offset-md="8"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  lg="4"
                >
                  <router-link
                    to="/clientes/clientes-rfv-faturado"
                    :style="styleObject"
                  >
                    <div
                      id="filtrosOpcoesClientesRFV"
                      class="text-center"
                    >
                      <v-icon id="iconCliente">
                        mdi-chart-bubble
                      </v-icon><br>
                      R.F.V
                    </div>
                  </router-link>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  lg="4"
                >
                  <router-link
                    to="/clientes/extrato-clientes-faturado"
                    :style="styleObject"
                  >
                    <div
                      id="filtrosOpcoesClientesExtrato"
                      class="text-center"
                    >
                      <v-icon id="iconCliente">
                        mdi-human-handsup
                      </v-icon><br>
                      Extrato de cliente
                    </div>
                  </router-link>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  lg="4"
                >
                  <router-link
                    to="/clientes/abc-clientes-faturado"
                    :style="styleObject"
                  >
                    <div
                      id="filtrosOpcoesClientesABC"
                      class="text-center"
                    >
                      <v-icon id="iconCliente">
                        mdi-card-account-details
                      </v-icon><br>
                      ABC de cliente
                    </div>
                  </router-link>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Como estão meus participantes?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              class="text-right"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('159')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <v-row>
                          <v-col
                            id="clientesParticantes"
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                            class="text-center"
                          >
                            Cobertura de participantes
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                            class="text-center"
                          >
                            <dashboard-cobertura-participantes /><br>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <div
                          v-if="loading"
                          :style="styleObject"
                          class="text-center"
                        >
                          <v-icon
                            light
                            class="custom-loader"
                            :style="styleObject"
                          >
                            mdi-cached
                          </v-icon>
                          Carregando dados...
                        </div>
                        <div
                          v-else-if="error"
                          class="alert alert-danger"
                        >
                          {{ error }}
                        </div>
                        <div
                          v-else
                        >
                          <v-row>
                            <v-col
                              cols="6"
                              class="text-center"
                            >
                              <span
                                id="clientePositivadosParticipantes"
                                :style="styleCliente"
                              >
                                <router-link
                                  to="/clientes/detalhe-clientes-faturado"
                                  :style="styleObject"
                                >
                                  <v-icon>
                                    mdi-arrow-top-right-bold-box-outline
                                  </v-icon><br>
                                </router-link>
                                {{ clientesFaturado }}
                              </span><br>
                              Positivados
                            </v-col>
                            <v-col
                              cols="6"
                              class="text-center"
                            >
                              <span
                                id="clientePositivadosParticipantes"
                                :style="styleCliente"
                              >
                                <router-link
                                  to="/clientes/detalhe-total-clientes"
                                  :style="styleObject"
                                >
                                  <v-icon>
                                    mdi-arrow-top-right-bold-box-outline
                                  </v-icon><br>
                                </router-link>
                                {{ clientesTotalAtivos }}
                              </span><br>
                              Ativos
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              v-if="clientesAtivos"
                              cols="6"
                              class="text-center"
                            >
                              <span
                                id="clientePositivadosParticipantes"
                                :style="styleCliente"
                              >
                                {{ clientesAtivos }}
                              </span><br>
                              Clientes Ativos
                            </v-col>
                            <v-col
                              v-if="fornecedoresAtivos"
                              cols="6"
                              class="text-center"
                            >
                              <span
                                id="clientePositivadosParticipantes"
                                :style="styleCliente"
                              >
                                {{ fornecedoresAtivos }}
                              </span><br>
                              Fornecedores Ativos
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col
                              v-if="produtoresAtivos"
                              cols="6"
                              class="text-center"
                            >
                              <span
                                id="clientePositivadosParticipantes"
                                :style="styleCliente"
                              >
                                {{ produtoresAtivos }}
                              </span><br>
                              Produtores Ativos
                            </v-col>
                            <v-col
                              v-if="funcionariosAtivos"
                              cols="6"
                              class="text-center"
                            >
                              <span
                                id="clientePositivadosParticipantes"
                                :style="styleCliente"
                              >
                                {{ funcionariosAtivos }}
                              </span><br>
                              Funcionários Ativos
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-actions><br>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Qual a distribuição geográfica dos meus clientes?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('160')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-maps-cliente />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="12"
                >
                  <v-card
                    id="cardDashbord"
                    class="mx-auto"
                    outlined
                  >
                    <div class="card-header-dashbord">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="10"
                          md="10"
                          lg="10"
                          class="d-flex flex-wrap"
                        >
                          E a participação de novos clientes?
                        </v-col>
                        <v-col
                          cols="12"
                          sm="2"
                          md="2"
                          lg="2"
                          class="d-flex justify-end"
                        >
                          <v-tooltip
                            top
                            max-width="400"
                            width="400"
                          >
                            <template
                              v-slot:activator="{ on, attrs }"
                            >
                              <v-icon
                                id="iconInformationFatxMetaComercial4"
                                class="text-left"
                                v-bind="attrs"
                                v-on="on"
                                @mouseover="enableTexto('161')"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <div
                              v-if="!carregandoTooltip"
                              v-html="textoOrientacao"
                            />
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </div>
                    <v-card-actions>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <div
                            v-if="loading"
                            :style="styleObject"
                            class="text-center"
                          >
                            <v-icon
                              light
                              class="custom-loader"
                              :style="styleObject"
                            >
                              mdi-cached
                            </v-icon>
                            Carregando dados...
                          </div>
                          <div
                            v-else-if="error"
                            class="alert alert-danger"
                          >
                            {{ error }}
                          </div>
                          <div v-else>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                              >
                                <v-row>
                                  <v-col
                                    cols="12"
                                    sm="10"
                                    md="10"
                                    lg="10"
                                  >
                                    <div
                                      id="textoClientesNovos"
                                      class="text-center"
                                      :style="styleCurrency"
                                    >
                                      {{ clientesNovos }} Clientes Novos
                                    </div>
                                  </v-col>
                                  <v-col
                                    cols="12"
                                    sm="2"
                                    md="2"
                                    lg="2"
                                  >
                                    <router-link
                                      to="/clientes/detalhe-novos-clientes-faturado"
                                      :style="styleObject"
                                    >
                                      <v-icon
                                        id="linkNovosClientes"
                                      >
                                        mdi-arrow-top-right-bold-box-outline
                                      </v-icon><br>
                                    </router-link>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row><br><br><br><br><br>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                              >
                                <div
                                  id="iconCombinado"
                                  class="text-center"
                                >
                                  <v-icon
                                    id="handCliente"
                                    :style="styleCurrency"
                                  >
                                    mdi-hand-extended-outline
                                  </v-icon>
                                  <v-icon
                                    id="currencyCliente"
                                    class="text-center"
                                    :style="styleCurrency"
                                  >
                                    mdi-currency-usd
                                  </v-icon>
                                </div>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                              >
                                <v-row
                                  id="textoParticipacao"
                                >
                                  Part. do Faturamento
                                </v-row>
                                <v-row
                                  id="percentualParticipacao"
                                >
                                  {{ participacaoClientesNovos }}
                                </v-row>
                              </v-col>
                            </v-row><br><br><br>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                              >
                                <div v-if="!text">
                                  <div
                                    v-if="loadingGrafico"
                                    id="carregaDados"
                                    class="text-center"
                                    :style="styleObject"
                                  >
                                    <v-icon
                                      light
                                      class="custom-loader"
                                      :style="styleObject"
                                    >
                                      mdi-cached
                                    </v-icon>
                                    Carregando Dados...
                                  </div>
                                  <div
                                    v-else-if="errorGrafico"
                                    class="alert alert-danger"
                                  >
                                    {{ errorGrafico }}
                                  </div>
                                  <canvas
                                    id="myChart34"
                                    width="180"
                                    height="130"
                                  />
                                  <br><br>
                                  <div
                                    v-if="exibirLegenda"
                                    id="legendaDistribuicaoCliente"
                                    class="text-center"
                                  >
                                    <v-row
                                      align="center"
                                      class="ma-0"
                                      no-gutters
                                    >
                                      <v-col
                                        md="6"
                                        offset-md="3"
                                      >
                                        <v-row>
                                          <div
                                            v-for="status in statusDistruibuicao"
                                            :key="status.statusExibicao"
                                          >
                                            <v-avatar
                                              class="mr-1"
                                              :color="status.corExibicao"
                                              size="12"
                                            />
                                            <span class="mr-3 font-weight-light">{{ status.statusExibicao }}</span>
                                          </div>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </div>
                                <div
                                  v-else
                                >
                                  {{ text }}
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteDsitruibicao"
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Como está a minha distribuição de clientes nos últimos 12 meses?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationFatxMetaComercial4"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('162')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-distribuicao-novos-clientes />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <show-dados-clientes-sem-faturamento />
        <v-row>
          <v-col
            id="componenteSegmentoParticipantes"
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <dashoard-card-view
              :exibir-texto-titulo="true"
              :code-information="'165'"
              :text="'Qual a segmentação predominante?'"
              :texto-information="textoParticpantesSegmento"
              :style-object="styleObject"
              :componente-grafico="true"
              :grafico-id="'myChart36'"
              :dados-grafico="chartSegmentacao"
              :titulo-id="'myChart36'"
              :legenda-grafico="statusSegmentacao"
              :exibir-legenda="true"
              :padding="dynamicPaddingCliente6"
              :loading="loadingGraficoSegmentacao"
            />
          </v-col>
          <v-col
            id="componenteSegmentoParticipantes"
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Quais são os 20 melhores clientes que performaram no ano?
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationFatxMetaComercial4"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('166')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <show-melhores-clientes />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteDevolucaoParticipantes"
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <show-dados-devolucoes-clientes />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            id="componenteDevolucaoParticipantes"
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <show-dados-perfomance-cliente />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            id="componenteDevolucaoParticipantes"
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <show-clientes-maiores-crescimento />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            id="componenteDevolucaoParticipantes"
            cols="12"
            sm="12"
            md="12"
            lg="6"
          >
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <show-clientes-piores-crescimento />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import Clientes from '../../../../services/clientes'
  import Chart from 'chart.js'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardClientes',
    emits: ['setCoberturaParticipantes', 'setLocalizcaoCliente', 'setFaturamentoNovosClientes', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashoardCardView: () => import('../../components/core/CardView'),
      DashboardCoberturaParticipantes: () => import('../../graficos/Clientes/CoberturaParticipantes'),
      DashboardMapsCliente: () => import('../../maps/Cliente/DashboardMapsCliente'),
      DashboardDistribuicaoNovosClientes: () => import('../../graficos/Clientes/DistribuicaoNovosClientes'),
      ShowDadosClientesSemFaturamento: () => import('../../components/comercial/clientes/ClientesSemFaturamento'),
      ShowMelhoresClientes: () => import('../../components/comercial/clientes/ClientesExibicaoMelhores'),
      ShowDadosDevolucoesClientes: () => import('../../components/comercial/clientes/ClientesDadosDevolucoes'),
      ShowDadosPerfomanceCliente: () => import('../../components/comercial/clientes/ClientesDadosPerfomance'),
      ShowClientesMaioresCrescimento: () => import('../../components/comercial/clientes/ClientesDadosMaioresCrescimento'),
      ShowClientesPioresCrescimento: () => import('../../components/comercial/clientes/ClientesDadosPioresCrescimento'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleCliente: {
        color: '#ed934f',
      },
      styleCurrency: {
        color: '#4CAF50',
      },
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      link: window.location.href,
      enableVendedores: true,
      enableAreas: true,
      enableRedes: true,
      enableSupervisor: true,
      enableReceita: true,
      enableSegmento: true,
      enableCategoria: true,
      enablePromotor: true,
      paginaEnable: false,
      permissaoClientes: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      clientesFaturado: 0,
      clientesTotalAtivos: 0,
      clientesAtivos: 0,
      fornecedoresAtivos: 0,
      produtoresAtivos: 0,
      funcionariosAtivos: 0,
      clientesNovos: 0,
      participacaoClientesNovos: 0,
      loading: false,
      loading1: false,
      error: null,
      error1: null,
      loadingGrafico: false,
      text: null,
      montaGrafico: true,
      errorGrafico: null,
      exibirLegenda: false,
      codigo: 0,
      orientacao: [],
      codigoIds: ['159', '160', '161', '162', '163', '164', '165', '166', '167', '168', '169', '170', '263', '264', '265', '266', '267', '268', '269', '270', '271', '272', '273', '274', '275', '276', '277', '278', '279', '280', '281', '282', '283', '284', '318', '319', '320', '321', '322', '323', '324', '325', '326', '327'],
      textoParticipantes: '',
      textoDistribuicaoParticipantes: '',
      textoParticipantesNovos: '',
      textoDistribuicaoMeses: '',
      textoPartipantesSemFat: '',
      textoPartipantesInativos: '',
      textoParticpantesSegmento: '',
      textoParticpantesMelhores: '',
      textoParticpantesDevolucao: '',
      textoParticpantesPerfomance: '',
      textoParticpantesCrescendo: '',
      textoParticpantesCaindo: '',
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart: {},
      statusDistruibuicao: [
        { statusExibicao: 'Clientes novos', corExibicao: '#4CAF50' },
        { statusExibicao: 'Clientes', corExibicao: '#E8F5E9' },
      ],
      chartDistribuicaoNovos: {},
      legendaDistribuicaoNovos: [],
      chartSegmentacao: {},
      statusSegmentacao: [
        { statusExibicao: 'Faturamento', corExibicao: '#4780b8' },
        { statusExibicao: 'Pareto', corExibicao: '#ed934f' },
      ],
      dynamicPaddingCliente1: '',
      dynamicPaddingCliente2: '',
      dynamicPaddingCliente3: '',
      dynamicPaddingCliente4: '',
      dynamicPaddingCliente6: '',
      dynamicPaddingCliente7: '',
      loadingGraficoSegmentacao: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Participantes')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingCliente1 = 'padding-right: 12rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 36rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 9rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 95rem !important'

          this.dynamicPaddingCliente6 = 'padding-right: 30rem !important'

          this.dynamicPaddingCliente7 = 'padding-right: 95rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingCliente1 = 'padding-right: 2rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 18rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 0.5rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 58rem !important'

          this.dynamicPaddingCliente6 = 'padding-right: 11.4rem !important'

          this.dynamicPaddingCliente7 = 'padding-right: 58rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingCliente1 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente6 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente7 = 'padding-right: 5rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingCliente1 = 'padding-right: 25rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 25rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 25rem !important'

          this.dynamicPaddingCliente6 = 'padding-right: 25rem !important'

          this.dynamicPaddingCliente7 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingCliente1 = 'padding-right: 2rem !important'

          this.dynamicPaddingCliente2 = 'padding-right: 17rem !important'

          this.dynamicPaddingCliente3 = 'padding-right: 5rem !important'

          this.dynamicPaddingCliente4 = 'padding-right: 55rem !important'

          this.dynamicPaddingCliente6 = 'padding-right: 14rem !important'

          this.dynamicPaddingCliente7 = 'padding-right: 13.1rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, classificacao, produto, cidade, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)

        this.updateDate()
      },

      updateDate () {
        this.clientesFaturado = 0
        this.clientesTotalAtivos = 0
        this.clientesAtivos = 0
        this.fornecedoresAtivos = 0
        this.produtoresAtivos = 0
        this.funcionariosAtivos = 0
        this.clientesNovos = 0
        this.participacaoClientesNovos = 0

        this.showDadosClientesFaturado()
        this.showDadosNovosClientes()
        this.MontarGrafico()
        this.showSegmento()

        this.loadingGraficoSegmentacao = true

        localStorage.setItem('vendedor', JSON.stringify(this.vendedorSelect || []))
        localStorage.setItem('area', JSON.stringify(this.areaSelect || []))
        localStorage.setItem('rede', JSON.stringify(this.redeSelect || []))
        localStorage.setItem('supervisor', JSON.stringify(this.supervisorSelect || []))

        eventEmit.$emit('set-localizcao-cliente', this.primeiroDia, this.ultimoDia, this.select, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor)
        eventEmit.$emit('set_faturamento_novos_clientes', this.primeiroDia, this.ultimoDia, this.select, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor)
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async showDadosClientesFaturado () {
        this.loading = true

        const empresaJson = JSON.stringify(this.select)

        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaId', empresaJson)

        await Clientes.showClientesFaturados(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.clientesFaturado = resposta.data.clientesFaturado
            this.clientesTotalAtivos = resposta.data.clientesTotalAtivos
            this.clientesAtivos = resposta.data.clientesAtivos
            this.fornecedoresAtivos = resposta.data.fornecedoresAtivos
            this.produtoresAtivos = resposta.data.produtoresAtivos
            this.funcionariosAtivos = resposta.data.funcionariosAtivos

            eventEmit.$emit('set-cobertura-participantes', this.clientesFaturado, this.clientesTotalAtivos)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },

      async showDadosNovosClientes () {
        this.loading1 = true

        await Clientes.showClientesNovos(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.clientesNovos = resposta.data.partNovosClientes

            const idsClientes = JSON.stringify(resposta.data.codClientes)

            localStorage.setItem('clientesId', idsClientes)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error1 = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading1 = false
        })
      },

      async MontarGrafico () {
        this.loadingGrafico = true
        this.exibirLegenda = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await Clientes.showComparativoClientes(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.participacaoClientesNovos = (resposta.data.participacao * 100).toFixed(2).replace('.', ',') + '%'

            const ctx = document.getElementById('myChart34').getContext('2d')

            this.myChart = new Chart(ctx, {
              type: 'horizontalBar',
              data: {
                labels: resposta.data.datas,
                datasets: [
                  {
                    label: 'Faturamento Novos Clientes',
                    data: resposta.data.faturamentoNovosClientes,
                    backgroundColor: '#4CAF50',
                    order: 1,
                  },
                  {
                    label: 'Faturamento Clientes',
                    data: resposta.data.faturamentoClientes,
                    backgroundColor: '#E8F5E9',
                    order: 2,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      if (tooltipItem.xLabel > 0) {
                        var type = data.datasets[tooltipItem.datasetIndex].label
                        var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                        return type + ': ' + valor
                      } else {
                        return null
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.text = resposta.data.mg

            this.errorGrafico = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.mg

            this.errorGrafico = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.errorGrafico = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loadingGrafico = false

          this.exibirLegenda = true
        })
      },

      async showSegmento () {
        if (this.chartSegmentacao.data) {
          this.chartSegmentacao.destroy()
        }

        await Clientes.showSegmentacaoClientes(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChart36').getContext('2d')

            this.chartSegmentacao = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Segmentação dos Clientes',
                    data: resposta.data.dadosExibicao,
                    backgroundColor: '#4780b8',
                    order: 2,
                  },
                  {
                    label: 'Pareto',
                    data: resposta.data.dadosLinhaGrafico,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 1) {
                        var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                        return ['Valor pareto: ' + valor,
                                'Porcentagem pareto: ' + resposta.data.pareto[tooltipItem.index].toFixed(2).toString().replace('.', ',') + '%',
                        ]
                      } else {
                        valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                        return valor
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 1) {
                        tooltipItem[0].xLabel = 'Pareto'

                        return tooltipItem[0].xLabel
                      } else {
                        tooltipItem[0].xLabel = 'Faturamento'

                        return tooltipItem[0].xLabel
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há meta no período selecionado') {
            this.text = resposta.data.mg

            this.error = this.text

            if (this.chartSegmentacao.data) {
              this.chartSegmentacao.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.text = resposta.data.mg

            this.error = this.text

            if (this.chartSegmentacao.data) {
              this.chartSegmentacao.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoSegmentacao = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 600px) {
    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    #iconInformationNovosClientesParcipantes {
      margin: auto;
    }

    #iconInformationNovosClientesParticipantes {
      margin: -7rem 0 0 0;
    }

    #linkNovosClientes {
      margin: -7.3rem 0 0 25rem;
    }

    #textoClientesNovosParticipantes {
      font-size: 22px;
      font-weight: bold;
      margin: -2rem 0 0 -11rem;
    }

    #iconCombinadoParticipantes {
      margin: -8rem 0 0 -20rem;
    }

    #textoParticipacaoParticipantes {
      margin: -11.5rem 0 0 8rem;
      font-size: 14px;
      font-weight: bold;
    }

    #percentualParticipacaoParticipantes {
      margin: 0 0 0 10rem;
      color: #4CAF50;
      font-size: 22px;
      font-weight: bold;
    }

    #filtrosOpcoesClientesRFV {
      color: black;
      margin: 0 0 0 -25rem;
    }

    #filtrosOpcoesClientesExtrato {
      color: black;
      margin: -6.6rem 0 0 -3rem;
    }

    #filtrosOpcoesClientesABC {
      color: black;
      margin: -8.2rem 0 0 21rem;
    }

    #idClientesParticantes {
      margin: -3rem 0 0 0;
    }

    #myChart34 {
      margin: -12rem 0 0 0;
    }

    #legendaDistribuicaoClienteParticipantes {
      font-size: 10px;
      margin: 1.5rem 0 1rem 10rem
    }

    #iconCombinado {
      margin: -5rem 0 0 -11rem
    }

    #textoParticipacao {
      margin: -9rem 0 0 13rem;
      font-size: 14px;
      font-weight: bold;
    }

    #percentualParticipacao {
      margin: 1rem 0 9rem 15rem
    }

    #legendaDistribuicaoCliente {
      margin: 0 0 2rem 6rem
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #iconInformationNovosClientesParcipantes {
      margin: auto;
    }

    #iconInformationNovosClientesParticipantes {
      margin: -7rem 0 0 0;
    }

    #linkNovosClientes {
      margin: -7.3rem 0 0 25rem;
    }

    #textoClientesNovosParticipantes {
      font-size: 22px;
      font-weight: bold;
      margin: 0 0 0 -11rem;
    }

    #iconCombinadoParticipantes {
      margin: -8rem 0 0 -20rem;
    }

    #textoParticipacao {
      margin: -11rem 0 0 12rem;
      font-size: 14px;
      font-weight: bold;
    }

    #percentualParticipacaoParticipantes {
      margin: 0 0 0 14rem;
      color: #4CAF50;
      font-size: 22px;
      font-weight: bold;
    }

    #filtrosOpcoesClientesRFV {
      color: black;
      margin: 2rem 0 0 -6rem;
    }

    #filtrosOpcoesClientesExtrato {
      color: black;
      margin: 2rem 0 0 1rem;
    }

    #filtrosOpcoesClientesABC {
      color: black;
      margin: 2rem 0 0 7rem;
    }

    #idClientesParticantes {
      margin: -1rem 0 0 0;
    }

    #myChart34 {
      margin: -12rem 0 0 0;
    }

    #legendaDistribuicaoClienteParticipantes {
      font-size: 10px;
      margin: 1rem 0 0 0;
    }
  }
</style>

<style lang="sass">
  #bloco1
    // margin-left: -5rem

  #opcoesClientes
    margin: -1rem 0 0 0

  #clientesParticantes
    font-size: 14px
    font-weight: bold

  #novosClientesParticipantes
    margin-left: -2rem

  #iconInformationNovosClientesParticipantes
    margin-left: -2rem

  #distribuicaoClientesParticipantes
    font-size: 14px
    font-weight: bold

  #partcipacaoNovosClientesParticipantes
    font-size: 14px
    font-weight: bold

  #clientePositivadosParticipantes
    font-size: 22px
    font-weight: bold

  #textoClientesNovosParticipantes
    font-size: 22px
    font-weight: bold

  #linkNovosClientes
    margin: 0.5rem 0 0 0

  #currencyClienteParticipantes
    margin: -5.5rem 0 0 -2.5rem
    font-size: 26px
    font-weight: bold

  #handCliente
    margin: -2rem 0 0 0
    font-size: 42px
    font-weight: bold

  #textoParticipacao
    margin: -3rem 0 0 -4.3rem
    font-size: 14px
    font-weight: bold

  #percentualParticipacaoParticipantes
    margin: 0 0 0 -4.3rem
    color: #4CAF50
    font-size: 22px
    font-weight: bold

  #linkDetalheMelhoresClientes
    color: black

  #filtrosOpcoesClientesRFV
    color: black

  #filtrosOpcoesClientesExtrato
    color: black

  #filtrosOpcoesClientesABC
    color: black

  #iconCliente
    font-size: 48px

  .container
    max-width: 100%

  #melhoresClientesParticipantes
    margin: -0.8rem 0 0 0rem

  #iconInformationMelhoresClientesParticipantes
    margin: -1.5rem 0 0 0

  #legendaDistribuicaoClienteParticipantes
    margin: 1.5rem 0 0 0
    font-size: 11px

  #myChart34
    margin: -3rem 0 0 0

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemClientes
    margin: -2rem 0 0 -1rem

  #listItemClientesMaps
    margin: -2rem 0 0 -1rem

  #listItemClientesNovos
    margin: -2rem 0 0 -1rem

  #listItemDistruibuicaoClientes
    margin: -2rem 0 0 -1rem

  #componenteDsitruibicao
    margin: -2rem 0 0 0rem

  #componenteSegmentoParticipantes
    margin: -2rem 0 0 0

  #componenteDevolucaoParticipantes
    margin: -4rem 0 0 0

  #listItemMelhoresParticipantes
    margin: -2rem 0 0 -1rem

</style>
